import React from 'react';
import { Flex, Modal, Typography } from 'antd';
import Button from 'components/Button/Button';
import styled from 'styled-components';
import SVGIcon from 'components/SVGIcon/SVGIcon';
import VoucherInValid from './voucher-invalid.png';
import messages from './messages';
import translations from 'translations';
import { VOUCHER_STATUS } from 'containers/CheckoutPage/constants';
import { FormattedMessage } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router-dom';

const ModalContainer = styled(Modal)`
  &.ant-modal .ant-modal-content {
    padding: 20px 12px;
    max-width: 382px;
    border-radius: 8px;
  }
`;

const PopupWrapper = styled(Flex)`
  max-width: 400px;
  text-align: center;
  color: #585a60;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
`;

const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  & > *.ant-typography {
    margin: 0;
    text-wrap: balance;
  }
`;

const ConfirmButton = styled(Button)`
  display: flex;
  height: max-content;
  min-width: 90px;
  padding: 14px 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  font-size: 16px;
  border-radius: 6px;
  color: #fff;
  text-align: center;
  font-weight: 600;
  line-height: 20px;
`;

interface Props extends RouteComponentProps {
  voucherStatus: VOUCHER_STATUS | null;
}

const InValidVoucherPopup: React.FC<Props> = ({ voucherStatus, history, location }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  React.useEffect(() => {
    if (voucherStatus) {
      setIsOpen(voucherStatus !== VOUCHER_STATUS.APPLIED);
    }
  }, [voucherStatus]);
  return (
    <ModalContainer
      title={null}
      footer={null}
      open={isOpen}
      closable={false}
      maskClosable={false}
      destroyOnClose
      centered
    >
      <PopupWrapper vertical align="center" gap={12}>
        <SVGIcon src={VoucherInValid} width={200} height={200} />
        <Box>
          <Typography.Title
            level={4}
            style={{
              fontSize: '24px',
              fontWeight: 500,
              lineHeight: '32px',
              color: '#242527',
            }}
          >
            {translations(messages.invalidTitle)}
          </Typography.Title>
          <Typography.Paragraph>{translations(messages.invalidDescription)}</Typography.Paragraph>
        </Box>
        <ConfirmButton
          type="bg-primary"
          block
          onClick={() => {
            setIsOpen(false);
            history.push('/checkout/step1');
          }}
        >
          <FormattedMessage {...messages.invalidAction} />
        </ConfirmButton>
      </PopupWrapper>
    </ModalContainer>
  );
};

export default withRouter(InValidVoucherPopup);
